require ('./checkbox.css');
var moo = require("@webhare-system/frameworks/mootools/core");
var domevents = require('@webhare-system/dom/events');
var domui = require('@webhare-system/internal/legacyui');

var $ = moo.$;
var Element = moo.Element;
var Class = moo.Class;
var Options = moo.Options;
var Events = moo.Events;


var Checkbox = new Class(
{ Implements: [ Options, Events ]

/* Initialization */

, options: { cssclass: ""    // Classname to apply
           , checked: false  // If the checkbox is initially selected (if no checkbox el is provided)
           , enabled: true   // If the checkbox is initially enabled (if no checkbox el is provided)
           , required: false
           , value: ""       // Checkbox value (if no checkbox el is provided)
           // onChange      // Called when the value was changed
           }

, el: null
, active: false
, tabindex: 0
, isinputcheckbox: false

, initialize: function(options, el) //FIXME reverse to more common ordering (But allow old-style calls)
  {
    this.setOptions(options);
    this.el = $(el);

    if (this.el)
    {
      this.options.checked = !!this.el.checked;
      this.options.enabled = !this.el.disabled;
      this.options.value = this.el.value;
      this.options.required = this.el.required;

      if (this.el.type == "checkbox")
      {
        this.isinputcheckbox = true;
      }
      domui.setupLabelDefaultHandler(); //make sure <label> focus() keeps working

      this.el.addEvent("wh-refresh", this.refresh.bind(this));
    }

    this.buildNode();
    this.updateState();
  }

, refresh: function()
  {
    this.options.checked = !!this.el.checked;
    this.options.enabled = !this.el.disabled;
    this.options.value   = this.el.value;
    this.options.required= this.el.required;

    this.updateState();
  }

/* Public API */
, toggle: function()
  {
    if (this.getEnabled())
      this.setChecked(!this.getChecked(), true);
  }

  /* Get the value */
, getValue: function()
  {
    return this.options.value;
  }

  /* Set the value */
, setValue: function(value, withevent)
  {
    this.setOptions({ value: value });
  }

  /* Get the checked value */
, getChecked: function()
  {
    return this.options.checked;
  }

  /* Set the checked value */
, setChecked: function(checked, withevent)
  {
    if (checked != this.options.checked)
      this.setCheckedInternal(checked, withevent, true);
  }

  /* Get the enabled state of the checkbox */
, getEnabled: function()
  {
    return this.options.enabled;
  }

  /* Get the required state of the checkbox */
, getRequired: function()
  {
    return this.options.required;
  }

  /* Set the enabled state of the checkbox */
, setEnabled: function(enabled)
  {
    if (enabled != this.options.enabled)
    {
      this.setOptions({ enabled: enabled });
      this.updateState();
      this.node.setAttribute("tabindex", this.options.enabled ? this.tabindex : -1); // Enable focus for key navigation
    }
  }

/* DOM */

, buildNode: function()
  {
    this.node = new Element("div", { "class": this.options.cssclass + (this.el && this.el.className ? " " + this.el.className : "")
                                   , events: { keydown: this.onKeyDown.bind(this)
                                             , click: this.onClick.bind(this)
                                             }
                                   });
    this.node.classList.add("wh-checkbox");

    this.node.appendChild(new Element("span", { "class": "value"}));

    if(this.el)
    {
      if (this.isinputcheckbox)
      {
        this.tabindex = this.el.get("tabindex") || 0;
        this.el.addEventListener("change", this.onInputChanged.bind(this));
      }
      domui.setupFormResetListener(this.el, this.onInputChanged.bind(this));
    }
    this.node.setAttribute("tabindex", this.options.enabled ? this.tabindex : -1); // Enable focus for key navigation
  }

, toElement: function()
  {
    return this.node;
  }

, updateState: function()
  {
    this.node.toggleClass("disabled", !this.getEnabled());
    this.node.toggleClass("checked", this.getChecked());
    this.node.toggleClass("required", this.getRequired());

    if (this.el)
    {
      if (this.isinputcheckbox)
        this.el.checked = this.getChecked();
      else
        this.el.value =  this.getChecked() ? this.options.value : "";
    }
  }

, onKeyDown: function(event)
  {
    if (this.getEnabled())
    {
      if (event.key == "space")
        return this.onClick(event);
    }
  }

, onInputChanged: function(event)
  {
    this.setChecked(this.el.checked);
  }
, onClick:function(evt)
  {
    evt.stop();

    if(this.el)
      domevents.fireHTMLEvent(this.el,'click'); //iscroll-compatible .click
    else
      this.toggle();
  }

/* Internal functions */

, setCheckedInternal: function(checked, withevent, recurse)
  {
    checked = !!checked;

    if (checked != this.options.checked)
    {
      this.setOptions({ checked: checked });
      this.updateState();
      if (withevent)
      {
        this.fireEvent("change", this);
        if(this.isinputcheckbox) //ADDME: Is this necessary if updateState changes the input's checked status?
          domevents.fireHTMLEvent(this.el, "change");
      }
      return true;
    }
    return false;
  }
});

function replaceCheckboxComponent(input, options)
{
  if(input.type!="checkbox")
    return;

  var comp = new Checkbox(options, input);

  // Replace the current input with the new checkbox's node
  input.setStyle("display", "none")
       .store("wh-ui-replacedby", $(comp))
       .parentNode.insertBefore($(comp), input);

  $(comp).store("wh-ui-replaces", input);
}

Checkbox.replaceComponents = function(selector, options)
{
  domui.setupReplaceableComponents(selector, replaceCheckboxComponent, options);
};

module.exports = Checkbox;



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/modules/tollium/web/ui/components/basecontrols/checkbox.js
// module id = 1133
// module chunks = 0